import { useSelector } from 'react-redux';
import type { LANG } from '../constants/languages';
import { isProvidedByEnabled } from '../store/selectors/features.selector';
import { getLang } from '../store/selectors/lang.selector';

/** Typed access to one section of the active language object. */
export function useLang<Section extends keyof LANG>(section: Section): LANG[Section] {
  return useSelector(getLang(section));
}

export const useVettedOrProvidedLang = (inputValue: string): string => {
  const isFeatureEnabled = useSelector(isProvidedByEnabled);
  const customLang = useLang('CUSTOM_LANG');

  // Lang objects are $set-replaced wholesale from Remote Config, so a key can be
  // missing until the upload lands — never crash the page over a label.
  if (!isFeatureEnabled || !inputValue) {
    return inputValue;
  }

  const normalizedValue = inputValue
    .replace(/Vetted|Validated/, customLang.PROVIDED)
    .replace(/vetted|validated/, customLang.PROVIDED_LOWERCASE);

  return normalizedValue;
};
